import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import AkkhorLayout from "../layout/akkhor";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import SearchBoxModal from "../component/SearchBoxModal";

export default function ImportHopDong() {
    const { user } = useSelector((state) => state.auth);
    const [file, setFile] = useState(null);
    const [typeId, setTypeId] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleImport = (event) => {
        event.preventDefault();
        if (!typeId) {
            confirmAlert({
                title: "Thiếu loại hợp đồng",
                message: "Vui lòng chọn loại hợp đồng trước khi import",
                buttons: [{ label: "OK" }],
            });
            return;
        }
        if (!file) {
            confirmAlert({
                title: "Thiếu file Excel",
                message: "Vui lòng chọn file Excel để import hợp đồng",
                buttons: [{ label: "OK" }],
            });
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type_id", typeId);

        setLoading(true);
        setResult(null);
        Axios.post(URL_LIST_ALL + "import_hopdong", formData, {
            ...user.config,
            headers: {
                ...(user.config && user.config.headers ? user.config.headers : {}),
                "Content-Type": "multipart/form-data",
            },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "success") {
                setResult(res.data);
            } else {
                confirmAlert({
                    title: "Lỗi import",
                    message: res.data.message || "Không import được hợp đồng",
                    buttons: [{ label: "OK" }],
                });
            }
        }).catch((err) => {
            setLoading(false);
            confirmAlert({
                title: "Lỗi import",
                message: err.message || "Không kết nối được tới máy chủ",
                buttons: [{ label: "OK" }],
            });
        });
    };

    return (
        <AkkhorLayout idrole="dashboard">
            {loading && <Spinner />}
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/hop-dong">Danh sách hợp đồng</Link>
                    </li>
                    <li>Import hợp đồng từ Excel</li>
                </ul>
            </div>

            <div className="card height-auto">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Import hợp đồng từ Excel</h3>
                        </div>
                        <div className="dropdown">
                            <Link className="btn-fill-lmd radius-30 text-light bg-dark-pastel-green" to="/hop-dong">
                                Danh sách hợp đồng
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-5 col-12">
                            <form onSubmit={handleImport}>
                                <div className="form-group">
                                    <label>Loại hợp đồng <span className="text-danger">*</span></label>
                                    <SearchBoxModal
                                        apiname={"hopdong_type"}
                                        placeholder="Chọn loại hợp đồng"
                                        colvalue={'id'}
                                        colname={'title'}
                                        defaultValue={typeId}
                                        name='type_id'
                                        onChange={(value) => setTypeId(value)}
                                    ></SearchBoxModal>
                                </div>
                                <div className="form-group">
                                    <label>File Excel <span className="text-danger">*</span></label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept=".xlsx,.xls"
                                        onChange={(event) => setFile(event.target.files && event.target.files[0] ? event.target.files[0] : null)}
                                    />
                                </div>
                                <button type="submit" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                                    Import hợp đồng
                                </button>
                                <a className="btn btn-sm btn-outline-success ms-2" href="/mau-import-hop-dong.xlsx" download>
                                    Tải file mẫu
                                </a>
                            </form>
                        </div>

                        <div className="col-lg-7 col-12">
                            <div className="border rounded p-3 bg-light">
                                <h5 className="mb-3">Quy định file Excel</h5>
                                <div className="mb-2">
                                    <strong>Cột bắt buộc:</strong>
                                    <div className="d-flex flex-wrap mt-2" style={{ gap: 8 }}>
                                        <code className="border rounded bg-white px-2 py-1">{"{code}"}</code>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <strong>Cột tùy biến:</strong>
                                    <p className="mb-1">
                                        Dùng đúng tham số tùy biến đã khai báo trong mẫu hợp đồng, ví dụ:
                                    </p>
                                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                        <code className="border rounded bg-white px-2 py-1">{"{luongchinhthuc}"}</code>
                                        <code className="border rounded bg-white px-2 py-1">{"{calamviec}"}</code>
                                        <code className="border rounded bg-white px-2 py-1">{"{phucap}"}</code>
                                    </div>
                                </div>
                                <div className="text-muted">
                                    Cột <code>{"{code}"}</code> là mã nhân viên. Loại hợp đồng được chọn trực tiếp trên giao diện import và áp dụng cho toàn bộ file.
                                </div>
                            </div>
                        </div>
                    </div>

                    {result &&
                        <div className="mt-4">
                            <div className="d-flex flex-wrap mb-3" style={{ gap: 8 }}>
                                <span className="border rounded px-3 py-2 bg-light">Tổng: <strong>{result.total}</strong></span>
                                <span className="border rounded px-3 py-2 bg-success text-white">Thành công: <strong>{result.success}</strong></span>
                                <span className="border rounded px-3 py-2 bg-danger text-white">Lỗi: <strong>{result.error}</strong></span>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Dòng</th>
                                            <th>Mã nhân viên</th>
                                            <th>Loại hợp đồng</th>
                                            <th>Trạng thái</th>
                                            <th>Thông tin</th>
                                            <th>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(result.data || []).map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.row}</td>
                                                <td>{item.code}</td>
                                                <td>{item.type}</td>
                                                <td>
                                                    {item.status === "success" ?
                                                        <span className="badge badge-success">Thành công</span> :
                                                        <span className="badge badge-danger">Lỗi</span>
                                                    }
                                                </td>
                                                <td>{item.title || item.message}</td>
                                                <td>
                                                    {item.status === "success" &&
                                                        <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                                                            <Link className="btn btn-sm btn-outline-primary" to={"/edit-hop-dong/" + item.id}>
                                                                Xem
                                                            </Link>
                                                            {item.file_url &&
                                                                <a className="btn btn-sm btn-outline-success" href={item.file_url} target="_blank" rel="noreferrer">
                                                                    Tải file
                                                                </a>
                                                            }
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </AkkhorLayout>
    );
}
